import React from "react";
import Layout from "./Layout";
import { useOtiService } from "./hooks/useOtiService";

export const UserApp = () => {
  useOtiService();

  return <Layout />;
};
